module.exports = __webpack_public_path__ + "assets/borlabs-cookie.e7822f8c.svg";